import React, {useState} from "react";
import {Card, CardBody, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {number, TagList} from "./common";

/**
 * GOD-TASK-197 Tags Automation: "Pause workflow X?" / "Delete workflow X?" with the Keep or Remove
 * choice for the tags it has already applied (prototype screen 6).
 *
 * mode: 'pause' | 'delete'. onConfirm(action) gets 'keep' or 'remove'.
 */
const WorkflowDialog = ({workflow, mode, busy, onCancel, onConfirm}) => {
    const [choice, setChoice] = useState('keep');
    const del = mode === 'delete';
    const tags = workflow.add_tags.length ? workflow.add_tags : [...workflow.remove_tags, ...(workflow.remove_patterns || [])];
    const tagWord = tags.length === 1 ? tags[0] : 'these tags';

    const option = (value, title, help) => (
        <Card className={`mb-2 ${choice === value ? 'border-primary' : ''}`} style={{cursor: 'pointer'}} onClick={() => setChoice(value)}>
            <CardBody className="p-3">
                <FormGroup check className="m-0">
                    <Input type="radio" name="ta-tag-choice" id={`ta-choice-${value}`} checked={choice === value} onChange={() => setChoice(value)}/>
                    <Label check for={`ta-choice-${value}`} className="f-w-600 mb-0">{title}</Label>
                    <div className="f-12 text-muted">{help}</div>
                </FormGroup>
            </CardBody>
        </Card>
    );

    return (
        <Modal isOpen centered size="lg" toggle={busy ? undefined : onCancel}>
            <ModalHeader toggle={busy ? undefined : onCancel}>{del ? 'Delete' : 'Pause'} workflow {workflow.name}?</ModalHeader>
            <ModalBody>
                <p className="text-muted">
                    {del ? 'The workflow and its conditions are deleted. This cannot be undone.' : 'The workflow stops evaluating products until you resume it.'}
                </p>
                <div className="d-flex align-items-center flex-wrap mb-3 f-12 text-muted" style={{gap: 6}}>
                    {tags.length === 1 ? 'Tag' : 'Tags'} {workflow.add_tags.length ? 'applied' : 'removed'} by this workflow:
                    <TagList tags={tags} kind={workflow.add_tags.length ? 'add' : 'remove'} limit={5}/>
                    on <b className="text-dark">{number(workflow.products_tagged)} {workflow.products_tagged === 1 ? 'product' : 'products'}</b>
                </div>
                {option('keep', 'Keep the tags on these products', del
                    ? 'The tags stay and are no longer managed. Remove one by hand from the product edit form.'
                    : 'The tags stay. Resuming the workflow takes them back under its management and re-evaluates them.')}
                {option('remove', 'Remove the tags from these products',
                    `Removed from Shopify through the normal sync. Products that another active workflow also tags with ${tagWord} keep it.`)}
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-light" onClick={onCancel} disabled={busy}>Cancel</button>
                <button type="button" className={`btn ${del ? 'btn-danger' : 'btn-primary'}`} onClick={() => onConfirm(choice)} disabled={busy}>
                    {del ? 'Delete workflow' : 'Pause workflow'}
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default WorkflowDialog;
